module.exports = __webpack_public_path__ + "static/media/gs.8b0eac6d.svg";